// LGPD/Fase 3.2: oculta dados pessoais (CPF, CNPJ, CEP) em previews de mensagem
// exibidos amplamente (lista de tickets, cards do Kanban) — onde qualquer
// atendente da fila veria o dado em texto puro.
//
// Aplicar SOMENTE em previews/snippets. Não usar no balão de mensagem aberto,
// onde o atendente precisa ler o conteúdo para atender.

const PII_PATTERNS = [
  // CNPJ antes de CPF (mais longo): 14 dígitos com separadores opcionais
  /\b\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}\b/g,
  // CPF: 11 dígitos
  /\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g,
  // CEP: 8 dígitos
  /\b\d{5}-?\d{3}\b/g,
];

const REDACTED = "[dado protegido]";

export function sanitizePiiPreview(text) {
  if (!text || typeof text !== "string") return text;
  let out = text;
  for (const re of PII_PATTERNS) {
    out = out.replace(re, REDACTED);
  }
  return out;
}

export default sanitizePiiPreview;
